import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import "antd/dist/reset.css";
import App from './App';
import { ConfigProvider } from "antd";
import { MessageProvider } from './components/MessageProvider';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#00C183",
          borderRadius: 8,

          controlHeight: 40,
          controlHeightSM: 40,
          controlHeightLG: 40,

          fontSize: 16,
          lineHeight: 1.2,
          fontFamily: "Inter, sans-serif",
        },
        components: {
          Button: {
            controlHeight: 40,
            paddingBlock: 0,
          },
          Input: {
            controlHeight: 40,
            paddingBlock: 0,
          },
          Select: {
            controlHeight: 40,
            paddingBlock: 0,
          },
        }
      }}

    >
      <MessageProvider>
        <App />
      </MessageProvider>
    </ConfigProvider>
);
